/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepConstraintDto } from './StepConstraintDto';
import {
    StepConstraintDtoFromJSON,
    StepConstraintDtoFromJSONTyped,
    StepConstraintDtoToJSON,
    StepConstraintDtoToJSONTyped,
} from './StepConstraintDto';

/**
 * Eligibility rule of the survey, for early client-side warnings. Constraint values are expressed as the front sees answers (possible answer key, JSON booleans). The server verdict at validation remains authoritative.
 * @export
 * @interface EligibilityRuleDto
 */
export interface EligibilityRuleDto {
    /**
     * Rule key (e.g. KILL_ENV_ZONE_SENSIBLE, ELIGIBLE_DEFAULT)
     * @type {string}
     * @memberof EligibilityRuleDto
     */
    key: string;
    /**
     * ELIGIBLE, NON_ELIGIBLE or PENDING
     * @type {string}
     * @memberof EligibilityRuleDto
     */
    result: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityRuleDto
     */
    reason?: string | null;
    /**
     * Human readable message shown when the rule is triggered
     * @type {string}
     * @memberof EligibilityRuleDto
     */
    message?: string | null;
    /**
     * Evaluation order — the first satisfied rule wins
     * @type {number}
     * @memberof EligibilityRuleDto
     */
    priority: number;
    /**
     * All constraints must be satisfied (logical AND)
     * @type {Array<StepConstraintDto>}
     * @memberof EligibilityRuleDto
     */
    constraints: Array<StepConstraintDto>;
}

/**
 * Check if a given object implements the EligibilityRuleDto interface.
 */
export function instanceOfEligibilityRuleDto(value: object): value is EligibilityRuleDto {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('constraints' in value) || value['constraints'] === undefined) return false;
    return true;
}

export function EligibilityRuleDtoFromJSON(json: any): EligibilityRuleDto {
    return EligibilityRuleDtoFromJSONTyped(json, false);
}

export function EligibilityRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'result': json['result'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'message': json['message'] == null ? undefined : json['message'],
        'priority': json['priority'],
        'constraints': ((json['constraints'] as Array<any>).map(StepConstraintDtoFromJSON)),
    };
}

export function EligibilityRuleDtoToJSON(json: any): EligibilityRuleDto {
    return EligibilityRuleDtoToJSONTyped(json, false);
}

export function EligibilityRuleDtoToJSONTyped(value?: EligibilityRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'result': value['result'],
        'reason': value['reason'],
        'message': value['message'],
        'priority': value['priority'],
        'constraints': ((value['constraints'] as Array<any>).map(StepConstraintDtoToJSON)),
    };
}

